module.exports = __webpack_public_path__ + "img/DE05781.ff1721ce.png";